import { createSelector } from 'reselect';
import * as CoreSelectors from '.';
import * as MerchSelectors from './merchandising';
import * as RouterSelectors from './router';
// eslint-disable-next-line import/prefer-default-export
export const activeManagerModelSelector = createSelector(CoreSelectors.activeModelTypeSelector, CoreSelectors.activeAreaSelector, RouterSelectors.activeQuerySelector, MerchSelectors.merchandisingSelector, (modelType, area, { id }, merchandising) => {
    const managerState = MerchSelectors.merchandisingManagerSelector(merchandising, modelType, area);
    return MerchSelectors.managerModelSelect(managerState, id);
});
